'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    Check: ()=>Check
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const index_cjs_namespaceObject = require("../../../utils/index.cjs");
const react_namespaceObject = require("motion/react");
const pathVariants = {
    normal: {
        scale: 1
    },
    animate: {
        pathLength: [
            0,
            1
        ]
    }
};
const Check = /*#__PURE__*/ (0, external_react_namespaceObject.forwardRef)(({ onMouseEnter, onMouseLeave, className, size = 24, ...props }, ref)=>{
    const controls = (0, react_namespaceObject.useAnimation)();
    const isControlledRef = (0, external_react_namespaceObject.useRef)(false);
    (0, external_react_namespaceObject.useImperativeHandle)(ref, ()=>{
        isControlledRef.current = true;
        return {
            startAnimation: ()=>controls.start('animate'),
            stopAnimation: ()=>controls.start('normal')
        };
    });
    const handleMouseEnter = (0, external_react_namespaceObject.useCallback)((e)=>{
        if (isControlledRef.current) onMouseEnter?.(e);
        else controls.start('animate');
    }, [
        controls,
        onMouseEnter
    ]);
    const handleMouseLeave = (0, external_react_namespaceObject.useCallback)((e)=>{
        if (isControlledRef.current) onMouseLeave?.(e);
        else controls.start('normal');
    }, [
        controls,
        onMouseLeave
    ]);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        className: (0, index_cjs_namespaceObject.cn)(className),
        ...props,
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: size,
            height: size,
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            className: "duration-long ease-in-out",
            role: "img",
            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(react_namespaceObject.motion.path, {
                variants: pathVariants,
                initial: "normal",
                animate: controls,
                d: "m5.5 12.5 4 4 9-9"
            })
        })
    });
});
exports.Check = __webpack_exports__.Check;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "Check"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
